import React, { useMemo } from 'react';
import DynamicTable from '@atlaskit/dynamic-table';
import { useIntl } from '@atlassian/jira-intl/src/index.tsx';
import type { ChartData } from '../../../common/summary/types.tsx';
import { createHead, createRows, type HighlightPointEvent } from './main';

type Props = {
	isDisabled?: boolean;
	source: ChartData;
	onSelect: (arg1: HighlightPointEvent) => void;
};

const paginationi18n = { next: '', prev: '' } as const;

export const SummaryTable = ({ source, onSelect, isDisabled }: Props) => {
	const { formatMessage } = useIntl();
	const head = useMemo(() => createHead(source, { formatMessage }), [formatMessage, source]);
	const rows = useMemo(
		() => createRows(source, { formatMessage, onClick: onSelect, isDisabled }),
		[formatMessage, isDisabled, onSelect, source],
	);
	return (
		<div data-test-id="servicedesk-reports-common.ui.table.summary-table.summary-table">
			{/* @ts-expect-error - TS2769 - No overload matches this call. */}
			<DynamicTable head={head} rows={rows} paginationi18n={paginationi18n} isFixedSize />
		</div>
	);
};
